import React from "react";
import ReactDOMServer from "react-dom/server";
import { showCommonAlert } from "../../../../shared/components/generic/alert/utils/show-common-alert-utils";
import MonetaryUtils from "../../../../shared/utils/MonetaryUtils";
import "./client-without-sales-history-alert.css";

const ClientWithoutSalesHistoryAlert = ({
	subtitle,
	averageMonthlySales
}) => (
	<div className="client-history-alert__body">
		<p className="client-history-alert__intro">
			{subtitle}
		</p>
	</div>
);

export const showClientWithoutSalesHistoryAlert = ({
	title,
	subtitle,
	averageMonthlySales
} = {}) => {
	const formattedAverageMonthlySales =
		MonetaryUtils.formatCurrency(averageMonthlySales) || "<R$xxx>";

	const formattedSubtitle = subtitle.replace(
		"{averageMonthlySales}",
		formattedAverageMonthlySales
	);

	const html = ReactDOMServer.renderToStaticMarkup(
		<ClientWithoutSalesHistoryAlert
			subtitle={formattedSubtitle}
			averageMonthlySales={formattedAverageMonthlySales}
		/>
	);

	return showCommonAlert({
		title,
		html,
		icon: "info",
		confirmButtonText: "Entendi",
		customClass: {
			popup: "client-history-alert",
			title: "client-history-alert__title",
			content: "client-history-alert__content",
			confirmButton: "alert-form-button"
		}
	});
};